/**
 * Fixed Header State
 *
 * Adds `header-fixed` to the rendered site header once the page is scrolled.
 * Supports both the block-theme `.site-header` wrapper and any legacy
 * `header.site-header` markup.
 *
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

export function initFixedHeader() {
    const header = document.querySelector('header.site-header, .site-header');

    if (!header) return;

    const updateHeaderState = () => {
        const isFixed = (window.scrollY || window.pageYOffset || 0) > 0;
        header.classList.toggle('header-fixed', isFixed);
    };

    updateHeaderState();

    let ticking = false;

    window.addEventListener('scroll', () => {
        if (ticking) return;

        requestAnimationFrame(() => {
            updateHeaderState();
            ticking = false;
        });

        ticking = true;
    }, { passive: true });
}